import React, { useMemo } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

import styles from './style';

interface CustomCardProps {
  children: React.ReactNode;
  // Optional: a card can hold only its children (ex: admin tabs, auth pages).
  title?: React.ReactNode;
  // Element on the right of the title, vertically centered with it (ex: "Voir plus").
  titleRight?: React.ReactNode;
  // The children handle their own spacing (ex: a table, a scrollable list or an auth body).
  noPadding?: boolean;
  sx?: SxProps<Theme>;
  bodySx?: SxProps<Theme>;
}

// Card of the connected pages and of the public pages (auth, contact, not found): same look everywhere.
const CustomCard: React.FC<CustomCardProps> = React.memo((props) => {
  const {
    children,
    title,
    titleRight,
    noPadding,
    sx,
    bodySx,
  } = props;

  const cardSx = useMemo(() => ({ ...styles.card, ...sx } as SxProps<Theme>), [sx]);

  const bodyStyle = useMemo(() => ({ ...styles.body, ...bodySx } as SxProps<Theme>), [bodySx]);

  return (
    <Box sx={cardSx}>
      {title && (
        <Box sx={styles.header}>
          <Typography component="h2" sx={styles.title}>{title}</Typography>
          {titleRight}
        </Box>
      )}
      {noPadding ? children : (
        <Box sx={bodyStyle}>
          {children}
        </Box>
      )}
    </Box>
  );
});

export default CustomCard;
